const fetchMessage = (responseCode, context) => {
  if(context.lastApiPath === 'no_notificate') 
    return null
  
  let messageKey = `apiErrors${context.lastApiPath}.${responseCode}`
  let message = context.$t(messageKey)

  if(message === messageKey) {
    messageKey = `apiErrors.default.${responseCode}`
    message = context.$t(messageKey)
  }

  if(message === messageKey) {
    messageKey = 'default'
    message = context.$t('default', { code: responseCode })
  }
  
  return message
}

export { fetchMessage }